import {
  Box,
  FormControl,
  Heading,
  IconButton,
  Input,
  InputGroup,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Page } from '../components/custom';
import { BlackArrowLeftIcon } from '../components/icons';
import AwaitingApprovalFilters from '../modules/Settings/AccountManagement/TransactionMandatesApproval/PendingTransactionsForApproval/AwaitingApprovalFilters';
import AwaitingApprovalTable from '../modules/Settings/AccountManagement/TransactionMandatesApproval/PendingTransactionsForApproval/AwaitingApprovalTable';
import { useAppSelector } from '../store/hooks';

export default function AwaitingApprovalPage() {
  const { status, value } = useAppSelector(
    (state) => state.getPendingTransactionsForApproval
  );

  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  // Filter transactions based on the search term
  const filteredTransactions = value?.data?.filter((transaction) => {
    const searchFields = [
      transaction?.recipient?.accountName,
      `${transaction?.initiatedBy?.user?.firstName} ${transaction?.initiatedBy?.user?.lastName}`,
      transaction?.transactionType,
    ];

    return searchFields.some((field) =>
      field?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  return (
    <Page title="Awaiting Approval | Merchant Banking - 9jaPay">
      <section>
        <Box display="flex" alignItems="center" gap={4} mb="2.125rem">
          <IconButton
            onClick={() => navigate('/app/dashboard')}
            aria-label="Go Back"
            variant="unstyled"
            icon={<BlackArrowLeftIcon />}
          />

          <Text color="richBlack.500">Dashboard</Text>
        </Box>
      </section>

      <section>
        <Stack
          direction={{ base: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems="baseline"
        >
          <Box>
            <Heading
              as="h1"
              fontWeight={500}
              fontSize="1.125rem"
              lineHeight="1.5rem"
              mb={1}
              maxW="335px"
            >
              All Awaiting Approval{' '}
              {status === 'success' && `- ${value?.data?.length}`}
            </Heading>
          </Box>

          <Box display="flex" gap="3">
            <form id="search-form">
              <Box
                display="flex"
                alignItems="center"
                gap={4}
                flexDirection={{ base: 'column', lg: 'row' }}
              >
                <FormControl
                  id="search-approval"
                  w={{ base: '100%', md: '335px' }}
                >
                  <InputGroup>
                    {/* <InputLeftElement pointerEvents="none" pt="4" pb="2.5">
                  <SearchIcon />
                </InputLeftElement> */}
                    <Input
                      variant="rounded"
                      autoComplete="new-password"
                      placeholder="Search Approval"
                      type="search"
                      value={searchTerm}
                      onChange={handleSearchChange}
                      sx={{
                        backgroundColor: 'ash.100',
                        borderRadius: '24px',
                        height: '44px',
                      }}
                      name="unique-search-field"
                      id="unique-search-field"
                    />
                  </InputGroup>
                </FormControl>
              </Box>
            </form>

            <AwaitingApprovalFilters />
          </Box>
        </Stack>
      </section>

      <section style={{ marginTop: '32px' }}>
        <Stack spacing={6}>
          <Box as="section">
            <AwaitingApprovalTable
              filteredTransactions={filteredTransactions}
            />
          </Box>
        </Stack>
      </section>
    </Page>
  );
}
